import React from "react";
import { IconButton, PlaySmallIcon, PauseSmallIcon } from "@activecollab/components";
import PropTypes from "prop-types";

const PlayPauseButton = ({ isPlaying, onPlay, onPause }) => {
  return !isPlaying ? (
    <IconButton
      variant="contained"
      size="small"
      className="stopwatch_switch_play_icon tw-absolute tw-shadow-none"
      onClick={onPlay}
    >
      <PlaySmallIcon />
    </IconButton>
  ) : (
    <>
      <IconButton
        variant="contained"
        size="small"
        className="stopwatch_switch_pause_icon tw-absolute tw-shadow-none"
        onClick={onPause}
      >
        <PauseSmallIcon />
      </IconButton>
    </>
  );
};

PlayPauseButton.propTypes = {
  isPlaying: PropTypes.bool,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
};

PlayPauseButton.displayName = "PlayPauseButton";

export default PlayPauseButton;
